"use client";

import { FC } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

type InputProps = {
  label: string;
  id: string;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  register: UseFormRegisterReturn;
  type?: string;
};

const InputText: FC<InputProps> = ({
  label,
  id,
  error,
  register,
  type = "text",
}) => {
  return (
    <label
      htmlFor={id}
      className={`grid p-3 bg-neutral-900 border rounded transition-colors ${
        error
          ? "border-red-500/70"
          : "border-neutral-300/10 focus-within:border-neutral-300/20"
      }`}
    >
      <span className={`mono ${error ? "text-red-400" : "opacity-60"}`}>
        {label}
      </span>
      <input
        id={id}
        type={type}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className="text-white text-lg outline-none bg-transparent autofill:bg-yellow-200"
        {...register}
      />
      {error ? (
        <span
          id={`${id}-error`}
          role="alert"
          className="mt-2 flex items-start gap-2 border-t border-red-500/30 pt-2 text-sm leading-snug text-red-400"
        >
          <span
            aria-hidden="true"
            className="inline-flex size-5 shrink-0 items-center justify-center rounded-sm bg-red-500 font-bold text-white"
          >
            !
          </span>
          <span>{error.toString()}</span>
        </span>
      ) : null}
    </label>
  );
};

export default InputText;
